import styled from '@emotion/styled'
import axios from 'axios'
import jwtDecode from 'jwt-decode'
import { useContext, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import Breakpoint from '../../Breakpoint'
import Label from '../../components/form/Label'
import CatchError from '../../components/global/CatchError'
import Title from '../../components/global/Title'
import { SERVER_URL } from '../../config'
import UserContext from '../../context/UserContext'
import { DecodedToken, roles } from '../../types/user.type'

const Login = () => {
    const [userConnect, setUserConnect] = useState('')
    const [password, setPassword] = useState('')
    const user = useContext(UserContext)

    const { t } = useTranslation('translation')
    const location = useLocation()

    const login = () => {
        axios
            .post(`${SERVER_URL}/users/login`, { userConnect, password })
            .then((res) => {
                const tokenDecoded: DecodedToken = jwtDecode(res.data)

                if (tokenDecoded.role === roles.ROLE_ADMIN) {
                    localStorage.setItem('tokenAdmin', 'Bearer ' + res.data)
                    user.tokenAdmin = localStorage.getItem('tokenAdmin') || false
                    user.adminData = tokenDecoded
                } else {
                    localStorage.setItem('tokenMember', 'Bearer ' + res.data)
                    user.tokenMember = localStorage.getItem('tokenMember') || false
                    user.memberData = tokenDecoded
                }

                window.location.reload()
            })
            .catch((err) => {
                CatchError(err.response.data)
            })
    }

    return (
        <LoginFormContainer>
            <LoginFormWrapper>
                <Title>
                    {t('page.login.connexion')}{' '}
                    {location.pathname.includes('bva-membre') ? t('page.login.member') : t('page.login.admin')}
                </Title>
                <LoginForm>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Label>Email ou Pseudo</Label>
                        <Form.Control
                            type="text"
                            placeholder="Entre ton email ou pseudo"
                            onChange={(e) => setUserConnect(e.target.value)}
                            value={userConnect}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Label>Mot de passe</Label>
                        <Form.Control
                            type="password"
                            placeholder="Entre ton mot de passe"
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                        />
                    </Form.Group>
                    <StyledButton
                        variant="primary"
                        type="button"
                        disabled={!userConnect || !password}
                        onClick={() => login()}
                    >
                        Se connecter
                    </StyledButton>
                </LoginForm>
            </LoginFormWrapper>
        </LoginFormContainer>
    )
}

export const StyledButton = styled(Button)`
    &:active {
        transform: scale(0.95);
    }
`

const LoginForm = styled(Form)`
    width: 100%;
`

const LoginFormContainer = styled.div`
    display: flex;
    width: 100%;
    height: calc(100vh - 166px);
    justify-content: center;
    align-items: center;

    @media (max-width: ${Breakpoint.LAPTOP_XS}) {
        padding: 16px;
    }
`

const LoginFormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 35%;
    border-radius: 6px;
    padding: 24px;
    background-color: white;
    justify-content: center;
    align-items: center;

    @media (max-width: ${Breakpoint.TABLET_L}) {
        width: 100%;
    }
`

export default Login
